import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VConsole from 'vconsole'

// vConsole 调试工具
// 开发环境自动启用，生产环境通过 URL 参数 isDev=true 或 debug=true 启用
// 支持 hash 路由： https://your-domain.com/#/?isDev=true
// 支持普通路由： https://your-domain.com/?debug=true
const fullUrl = location.search + location.hash
const isDebug = process.env.NODE_ENV === 'development' || 
                fullUrl.includes('debug=true') ||
                fullUrl.includes('isDev=true')
if (isDebug) {
  new VConsole()
  console.log('[vConsole] 调试模式已启用')
}

Vue.config.productionTip = false

// 企业微信全局配置
Vue.prototype.$wecomConfig = {
  // 企业ID - 在企业微信管理后台 > 我的企业 > 企业信息 中查看
  corpId: 'wwc9d4af920d011b75',
  // 应用AgentId - 在企业微信管理后台 > 应用管理 > 自建应用 中查看
  agentId: '1000023',
  // 后端接口地址
  signatureApi: 'https://api2.yingzi.cangkugou.xin',
    // 后端接口地址
  // signatureApi: 'http://localhost:8081',
}

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
